import { render, staticRenderFns } from "./CmgIneligibleOrderCard.vue?vue&type=template&id=37fec15f&scoped=true&lang=pug&"
import script from "./cmg-ineligible-order-card.ts?vue&type=script&lang=ts&"
export * from "./cmg-ineligible-order-card.ts?vue&type=script&lang=ts&"
import style0 from "./CmgIneligibleOrderCard.vue?vue&type=style&index=0&id=37fec15f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37fec15f",
  null
  
)

export default component.exports